// extracted by mini-css-extract-plugin
export default {"partnerCon":"Partner_partnerCon__naKA3","partnerBox":"Partner_partnerBox__m7am1","scroll":"Partner_scroll__Lkq0a","img":"Partner_img__ECjkC"};